module.exports = __webpack_public_path__ + "static/media/address_image.fa924ed6.svg";